import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nx/angular';

import * as CustomFieldsActions from './custom-fields.actions';
import { CustomFieldsService } from '../custom-fields.service';
import { map } from 'rxjs/operators';

@Injectable()
export class CustomFieldsEffects {
    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomFieldsActions.init),
            fetch({
                run: action => {
                    return this.service
                        .getCustomFields(action.parent, action.query)
                        .pipe(
                            map(customFields =>
                                CustomFieldsActions.loadCustomFieldsSuccess({
                                    customFields,
                                })
                            )
                        );
                },
                onError: (action, error) => {
                    console.error('Error', error);
                    return CustomFieldsActions.loadCustomFieldsFailure({
                        error,
                    });
                },
            })
        )
    );

    constructor(
        private readonly actions$: Actions,
        private service: CustomFieldsService
    ) {}
}
